<script>
  import router from 'page';
  import { onMount } from 'svelte';
  import { Entrypoint } from 'telekinesis-js';
  import * as TK from 'telekinesis-js';
  import 'purecss';

  import content from './content.json';

  import SignIn from './SignIn.svelte';
  import Stats from './Stats.svelte';

  import NavBar from './components/NavBar.svelte';
  import Footer from './components/Footer.svelte';
  import DocViewer from './components/DocViewer.svelte';
  import Register from './Register.svelte';
  import Node from './Node.svelte';
  import Executor from './Executor.svelte';
  // import LayoutTest from './LayoutTest.svelte';
  import PathBar from './components/PathBar.svelte';

  window.content = content
  let page;
  let sessionKey = localStorage.getItem('telekinesisCloudSession') || undefined;
  let backend = new Entrypoint(
    // 'ws://localhost:8776',
    'wss://telekinesis.cloud',
    sessionKey
  );

  let innerWidth;
  window.backend = backend;
  let stats = null//backend.get('telekinesis-inc/stats')()
  

  // let registerStat = async () => null; //backend.run('telekinesis-inc/stats');
  let user;
  let params;
  let path, pathBarMode;
  let title;

  onMount(async () => {

    window.TK = TK; 
    window.router = router;
    if (sessionKey) {
      user = backend.authenticate(x => {console.log(x)})._subscribe(x => {user = x._proxy; window.user = user});
    } else {
      user = backend//._subscribe(x => {user = x; window.user = user}).then();
      window.user = user;
    }
    router('/sign_in', async () => {
      page = SignIn;
	  title = 'Sign in'
      params = {
        authenticate: backend.authenticate,
        setUser: u => {user = u; window.user = u},
        router
      };
      window.scrollTo(0, 0);
      // stats.record('sign_in').then(() => null)
    })
    router('/stats', () => {
      window.scrollTo(0, 0);
      page = Stats;
      params = {
        stats
      };
      // stats.record('stats').then(() => null)
    })
    router('/register', () => {
      window.scrollTo(0, 0);
      page = Register;
	  title = 'Register'
      // stats.record('register').then(() => null)
      // params = {
      //   user, 
      //   selectedUse: 'sign_in'
      // };
    })
    router('/n/*', (ctx) => {
      page = Node;
      path = ctx.params[0];
      path = path[path.length-1] == '/' ? path.slice(0, path.length-1) : path;
	  title = `Node<${path}>`
      params = {path, user, router};
      pathBarMode = 'n'
      window.scrollTo(0, 0);
      // stats.record(ctx.params[0]).then(() => null);
    })
    // router('/x/*', (ctx) => {
    //   page = Executor;
    //   path = ctx.params[0];
    //   path = path[path.length-1] == '/' ? path.slice(0, path.length-1) : path;
	  // title = `ExecuteOnlyNode<${path}>`
    //   params = {path, user, router};
    //   pathBarMode = 'x'
    //   window.scrollTo(0, 0);
    //   // stats.record(ctx.params[0]).then(() => null);
    // })
    // router('/', () => {
    //   page = Node;//LayoutTest;
    //   params = { path: 'test-user', user, router};
    //   // params = { path: 'e-neuman', user, router};
    //   path = params.path;
    //   pathBarMode = 'n'
    //   window.scrollTo(0, 0);
    // })
    router('/', () => {
      window.location.replace('https://payperrun.com')
    })
    router('/*', (ctx) => {
      page = DocViewer;
      path = null;
      params = { source: content['/'+ctx.params[0]], user};
	  title = undefined;
      window.scrollTo(0, 0);
      // stats.record(ctx.params[0]).then(() => null);
    })

    router.start();
    user = await user;
    stats = await stats
    // stats.record('begin').then(() => null);
    window.user = user;
    window.stats = stats
    window.router = router;
    // if (sessionKey) {
    //   loading = false;
    //   window.user2 = user;
    // }
  })

</script>

<svelte:head><title>Telekinesis.Cloud | {title || "Serverless to ship faster"}</title></svelte:head>
<svelte:window bind:innerWidth={innerWidth}/>

<NavBar>
  {#if !path}
    <div style='flex-grow: 1;'/>
  {/if}
    <div style="display: flex; align-items: center">
      <!-- <a class="" href="/" style="padding: 0px; margin-right: 8px">
        <img src='/favicon.png' class='' alt='≈' style='height: 48px;'/>
      </a> -->
      <a class="" href="/" style="font-weight: 800; font-size: 24px; color: 'var(--primary-color)'; font-family: monospace">
        telekinesis<span style="background-color: var(--primary); color: var(--background); border-radius: 15px; padding: 5px 10px 5px 5px; margin: 5px;">.cloud</span>
      </a>
    </div>
  {#if path}
    <PathBar path={path} mode={pathBarMode} />
  {/if}
  <div style='flex-grow: 1;'/>
  <!-- <a href='/n/test-user/asdf'>dashboard</a> -->
  <!--   {#if loading}
    <WaitingFor style="margin-left: auto; color: var(--tertiary-color);"/>
  {:else if user?.id._lastValue}

    <a href='/dashboard/' style="margin-left: auto; font-size: 18px; background-color: var(--tertiary-color); color: var(--background); border-radius:15px; height: 20px; width: 20px; text-align: center; line-height: 18px">
      {user.id._lastValue[0].toUpperCase()}
    </a>
  {:else} -->
  <!-- {#if user}
    <JoinWaitlist style="margin: 0px 20px 0px 0px" user={user} short={innerWidth < 600}/>
  {/if}  -->
</NavBar>

<main>
  <svelte:component this={page} {...params} />
  <div id='filler'></div>
</main>

<Footer>
  <p> 
    <a href="mailto:contact@telekinesis.cloud">contact@telekinesis.cloud</a>
    <br><br>
    <a href="/about/terms">Terms & Conditions</a> - <a href="/about/privacy">Privacy Policy</a> - <a href="/sign_in">Sign In</a> 
    <br><br>
    © 2022 Telekinesis, Inc.</p>
</Footer>


<style>
  main {
    min-height: calc(100vh - 80px);
    box-shadow: 0px -5px 15px #aaa;
    width: 100%;
    margin: 0;
    display: flex;
    text-align: center;
    flex-direction: column;
    z-index: -99;
    overflow-x: hidden;
  }
  #filler {
    width: 100%;
    background-color: var(--background);
    flex-grow: 1;
  }
</style>
